import { render } from "./AuthSection.vue?vue&type=template&id=05e46a5e"
import script from "./AuthSection.vue?vue&type=script&lang=js"
export * from "./AuthSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__